import { apiHolder, isElectron } from 'api';
import { navigate } from '@reach/router';
const { isMac } = apiHolder.env;
const systemApi = apiHolder.api.getSystemApi();
const inElectron = isElectron();
export const isWinApp = systemApi.isElectron() && !isMac;
export const add = () => { };
export const AI_STAFF_GUIDE = 'AI_STAFF_GUIDE_KEY-0809';
export const KIND_OF_AVATAR = 4;
export const getEnterpriseInfoPayload = (infos) => {
    return infos.reduce((accumulator, info) => {
        return Object.assign(Object.assign({}, accumulator), info === null || info === void 0 ? void 0 : info.val);
    }, {});
};
export const formatToSearchDate = (moments) => {
    if (!moments)
        return;
    const start = moments[0].format('YYYYMMDD');
    const end = moments[1].format('YYYYMMDD');
    return `${start}-${end}`;
};
export const getAiPageActive = (hash) => ['#aiStaff', '#aiTeam'].some(item => hash.startsWith(item));
export const stringToJSON = (str) => {
    let data = {};
    try {
        data = JSON.parse(str || '{}');
    }
    catch (error) { }
    return data;
};
export const getHttpErrMessage = (err) => {
    var _a;
    return (err === null || err === void 0 ? void 0 : err.message) || ((_a = err === null || err === void 0 ? void 0 : err.data) === null || _a === void 0 ? void 0 : _a.message);
};
export const openNewTab = (path) => {
    if (inElectron) {
        navigate(path);
    }
    else {
        window && window.open(path);
    }
};
